var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb-5"},[_c('Button',{attrs:{"icon":"fas fa-trash-alt","buttonStyle":{ color: 'red' },"label":_vm.$t('remove')},on:{"click":_vm.remove}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }